export default __webpack_public_path__ + "static/footbg-0b70d291380a17bec1bc377c6d12c7a1.jpg";